export default {
  namespaced: true,
  state: {
    auditStateEnum: [
      {label: '待审核', value: 1},
      {label: '已通过', value: 3},
      {label: '已拒绝', value: 2},
    ],
    activityStatus: [
      {label: '即将开始', value: 0},
      {label: '报名中', value: 1},
      {label: '已结束', value: 2},
    ]
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/training/index.js